const isMaybeFormat = (link: string) => link.includes('/-/quality/best/');

const addFormat = (link: string) => `${link}-/format/jpeg/`;

export default (link: string) =>
  `https://static.onetwotrip.com/img/v1/r?size=800x600&url=${
    isMaybeFormat(link) ? addFormat(link) : link
  }`;
